import { ChevronDown } from "lucide-react";
import { ICompactChartData } from "@/interfaces/dashboard.interface";
import { Skeleton } from "../ui/skeleton";

interface CompactChartCardProps {
  data: ICompactChartData;
  isLoading?: boolean;
}

export default function CompactChartCard({ data, isLoading }: CompactChartCardProps) {
  const isPositive = data.percentage >= 0;

  return (
    <div className="bg-[#15203C] rounded-[20px] px-[30px] py-[16.5px] w-full lg:w-[444px] h-[227px] flex flex-col justify-center">
      {isLoading ? (
        <Skeleton className="h-full" />
      ) : (
        <>
          {/* Header */}
          <div className="flex flex-col gap-[10px] mb-[19px]">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <h3 className="text-base font-semibold text-[#F6F6F6]">{data.title}</h3>
                <div className="bg-[#0C1427] rounded-[20px] px-[10px] py-1 h-[23px] flex items-center justify-center">
                  <p className={`text-xs ${isPositive ? 'text-[#13D480]' : 'text-[#DC4426]'}`}>
                    {isPositive ? '+' : ''}{data.percentage}%
                  </p>
                </div>
              </div>
              <button className="flex items-center gap-1 text-xs text-[#888888] hover:text-white transition-colors">
                <span>{data.period}</span>
                <ChevronDown className="size-4" />
              </button>
            </div>

            {/* Value */}
            <p className="text-xl font-bold text-white">{data.value}</p>
          </div>

          {/* Chart - 5 Bars with 2 segments each */}
          <div className="flex gap-[32px] items-end mb-[19px]">
            {data.chartData.slice(0, 5).map((item, index) => (
              <div key={index} className="flex gap-[5px] items-end">
                <div
                  className="bg-[#7846FF] w-[23px] rounded-t-[4px]"
                  style={{ height: `${item.value1}px` }}
                />
                <div
                  className="bg-[#BFB1FF] w-[23px] rounded-t-[4px]"
                  style={{ height: `${item.value2}px` }}
                />
              </div>
            ))}
          </div>

          {/* Legend with Percentages */}
          <div className="flex flex-col gap-[6px]">
            {data.legend.map((item, index) => (
              <div key={index} className="flex items-center justify-between">
                <div className="flex items-center gap-[10px]">
                  <div
                    className="size-[7px] rounded-full"
                    style={{ backgroundColor: item.color }}
                  />
                  <p className="text-xs text-white">{item.label}</p>
                </div>
                <p className="text-xs text-white">{item.percentage}%</p>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
